import "./styles/profileFileModal.css";
import React from "react";
import axios from "axios";
import FileUploader from "../components/FileUploader";

class ProfileFileModal extends React.Component{
    constructor(props){
        super(props);
        this.state={
            regions:[],
            provinces:[],
            districts:[],
            regionShow:false,
            provinceShow:false,
            districtShow:false,
            regionFlag: true,
            provinceFlag:true,
            districtFlag:true,
            loadingFlag:false,
            regionSearch:this.props.regionDescription,
            provinceSearch:this.props.provinceDescription,
            districtSearch:this.props.districtDescription,
            regionId:'',
            provinceId:'',
            districtId:'',
            data:[],
            idPolitician:this.props.idPolitician,
            name:this.props.name,
            surnameFather:this.props.surnameFather,
            surnameMother:this.props.surnameMother,
            birthDate:this.props.birthDate,
            day:'',
            month:'',
            year:"",
            regionDescription:this.props.regionDescription,
            provinceDescription:this.props.provinceDescription,
            districtDescription:this.props.districtDescription,
            actualWork:this.props.actualWork,
            maxGrade:this.props.maxGrade,
            income:this.props.income,
            politicalParty:this.props.politicalParty,
        }
    }


    handleOnFocusOut(e){
        
        setTimeout(function() {
            var recomendationRegions=document.getElementsByClassName('profileFileModal__'+e.target.name+'RecomendationGroup');
            recomendationRegions.item(0).style.display="none";
          }, 200);
    }
    updateLoadingFlag=()=>{
        this.setState({
            loadingFlag:true

        });
    }

    handleOnChange=(e)=>{
        // console.log(e);
        this.setState({
            [e.target.name]:e.target.value

        });
    }
    componentDidMount(){
        // console.log("this is flagModal"+this.props.flagModal);
    }
    componentWillUnmount(){
        // console.log("did unmount");
    }
    render(){
        if(this.props.flagCv || this.props.flagPlan || this.props.flagTeam){
            return(
                <div onClick={this.props.handleCancelFileModal} className="profileFileModalWrapper">
                <div onClick={(e) => e.stopPropagation()} className="profileFileModalContainer">
                    <div className="profileFileModal__header">
                    {this.props.messageHeader}
                    </div>
                    <div className="profileFileModal__body">
                        <div className="profileFileModal__item">
                        <FileUploader 
                        handleCancelFileModal={this.props.handleCancelFileModal}
                        idPolitician={this.props.idPolitician} 
                        flagCv={this.props.flagCv}
                        flagPlan={this.props.flagPlan}
                        flagTeam={this.props.flagTeam}
                        updateLoadingFlag={this.updateLoadingFlag}

                        />
                        </div>
                    </div>
                    {this.state.loadingFlag &&
                    <div className="profileFileModal__loading">
                    </div>
                    }
                </div>
                </div>

            );
        }else{
            return null;
        }

    }
}

export default ProfileFileModal;